// extracted by mini-css-extract-plugin
export default {"external":"a4lbLD","grid":"b4lbLD","block":"c4lbLD","text":"d4lbLD","chevron":"e4lbLD","wrappedText":"f4lbLD"};